const STAGGER_FACTOR = 0.25;
const DESKTOP_BREAKPOINT = 992;

/**
 * Section Text Image Keyfacts
 */
export class SectionTextImageKeyfacts {

	#element;

	#cards;

	#viewportHeight;

	#viewportHeightHalf;

	#cardHeight;

	#isDesktop;

	/**
	 * Constructor
	 * @param {Element} element The element to initialize the section text image keyfacts on
	 */
	constructor( element ) {

		this.updateParallax = this.updateParallax.bind( this );

		this.#element = element;
		this.#cards = this.#element.querySelectorAll( ".b-card-keyfact" );

		this.#handleResize(); // Init
		this.#init();

		window.addEventListener( "resize", this.#handleResize.bind( this ) );

	}

	/**
	 * Initialize the section text image keyfacts
	 * @return {void}
	 */
	#init() {

		if ( window.matchMedia( "(prefers-reduced-motion: reduce)" ).matches ) {

			return;

		}

		window.requestAnimationFrame( this.updateParallax );

	}

	/**
	 * Update the parallax effect
	 * @return {void}
	 */
	updateParallax() {

		const sectionRect = this.#element.getBoundingClientRect();
		const sectionMiddle = sectionRect.top + sectionRect.height / 2;

		if (
			this.#isDesktop &&
			sectionRect.top <= this.#viewportHeight &&
			sectionMiddle >= this.#viewportHeightHalf
		) {

			// Desktop behavior

			// Handle parallax between section middle reaches viewport bottom and section middle reaches viewport middle
			const scrollProgress = Math.max(
				0,
				( this.#viewportHeight - sectionMiddle ) /
					this.#viewportHeightHalf,
			);

			// Cards move from bottom to top: start positive (down), end negative (up)
			const offset = -1 * ( 1 - scrollProgress ) * this.#cardHeight;

			this.#cards.forEach( ( card, index ) => {

				// Stagger increases with scroll progress - last card ends at 0, first cards stay shifted up
				const reverseIndex = this.#cards.length - 1 - index;
				const stagger =
					reverseIndex *
					STAGGER_FACTOR *
					scrollProgress *
					this.#cardHeight;
				const cardOffset = offset - stagger;
				card.style.transform = `translateY(${cardOffset}px)`;

			} );

		}

		window.requestAnimationFrame( this.updateParallax );

	}

	/**
	 * Handle resize
	 * @return {void}
	 */
	#handleResize() {

		this.#viewportHeight = window.innerHeight;
		this.#viewportHeightHalf = window.innerHeight / 2;
		this.#cardHeight = this.#cards[0].offsetHeight;

		this.#isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT;

	}

}
